import { useNavigate } from '@tanstack/react-router';
import { type ReactNode, useEffect } from 'react';
import { useAuth } from '@/lib/auth-state';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.status === 'signed-out') {
      void navigate({ to: '/login' });
    }
  }, [state.status, navigate]);

  if (state.status === 'loading') {
    return <div className="p-8 text-muted-foreground">Loading…</div>;
  }
  if (state.status === 'signed-out') {
    return <div className="p-8 text-muted-foreground">Redirecting to sign in…</div>;
  }
  return <>{children}</>;
}
